import { getInitials } from '../../../../utilities/helpers';

export const getCurrentTime = () => {
  return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const getFormattedDate = (date, locale) => {
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return date.toLocaleDateString(locale, options).toUpperCase();
};

// Estrategia de fallback (Props > Estado > Catálogo) para garantizar ID de mercado en distintos contextos.
export const getStorefrontId = ({ storefrontData }, state) => {
  const { Manage, StoreFront } = state;
  const { stateStoreFront, storefront } = Manage;
  const { storeFronts } = StoreFront;

  if (storefrontData?.storefrontId) return storefrontData.storefrontId;
  if (storefrontData?.id) return storefrontData.id;
  if (stateStoreFront?.storefrontId) return stateStoreFront.storefrontId;
  if (storeFronts && storefront) {
    const matchingStorefront = storeFronts.find(sf => sf.storefront && sf.storefront.identifier === storefront);
    if (matchingStorefront && matchingStorefront.storefront.id) return matchingStorefront.storefront.id;
  }
  return null;
};

export const getUserInitials = (name) => {
  return getInitials(name);
};
